import pdf from '@/sui/tools/pdf'

function getTitle (s, wp) {
  const n = s.establishment.name
  const f = s.establishment.finess
  const uf = s.modules.reaSink.uf
  return `${n} (${f}) / UF «${uf.name}» / CHAMBRE «${wp.room}» / POINT D'EAU «${wp.name}» / ID «${wp.id}»`
}

const colors = {
  stop: '#666666',
  no: '#aaaaaa'
}

function pyo () {
  const body = [
    [
      {
        text: `PYO : ______________________`,
        colSpan: 4
      }, {}, {}, {}
    ],
    [
      'CEFTA\n_____________',
      'IMP\n_____________',
      'Coris\nPCR',
      'Résultat'
    ],
    [
      { text: 'I/R', rowSpan: 2 },
      { text: 'I/R' },
      { text: 'Oui' },
      { text: 'CEFTA  I/R   S     IMP  I/R    S', border: nobot }
    ],
    [
      {},
      { text: 'S' },
      { text: 'Non', fillColor: colors.no },
      {
        style: 'left',
        columnGap: 3,
        columns: [
          {},
          {},
          {
            image: 'checkbox', width: 8
          },
          {
            text: 'VIM'
          },
          {
            image: 'checkbox', width: 8
          },
          'IMP',
          {
            image: 'checkbox', width: 8
          },
          'GES',
          {
            image: 'checkbox', width: 8
          },
          'NEG',
          {}, {}
        ],
        border: novert
      }
    ],
    [
      { text: 'S', rowSpan: 2 },
      { text: 'I/R' },
      { text: 'Oui' },
      { text: '', border: novert }
    ],
    [
      {},
      { text: 'S' },
      { text: 'Non', fillColor: colors.no },
      { text: 'Souche : __________________', border: notop }
    ]
  ]
  return {
    fontSize: 8,
    style: [ 'center', 'bold' ],
    margin: [ 0, 4, 0, 4 ],
    table: {
      widths: [ 50, 50, 24, 216 ],
      body: body
    }
  }
}

function epc () {
  const body = [
    [
      {
        text: `EPC : ______________________`,
        colSpan: 5
      }, {}, {}, {}, {}
    ],
    [
      'BANDELETTE\n____________ / ____________',
      'ERTA\n _____________',
      'CEFTA\n_____________',
      'Coris\nPCR',
      'Résultat'
    ],
    [
      { text: '+', rowSpan: 3 },
      { text: 'I/R', rowSpan: 2 },
      { text: 'I/R' },
      { text: 'Oui' },
      { text: 'EBLSE  +    -     PCR  +    -', border: nobot }
    ],
    [
      {},
      {},
      { text: 'S' },
      { text: 'Non', fillColor: colors.no },
      {
        style: 'left',
        columnGap: 3,
        columns: [
          {
            image: 'checkbox', width: 8
          },
          'KPC',
          {
            image: 'checkbox', width: 8
          },
          'OXA',
          {
            image: 'checkbox', width: 8
          },
          'NDM'
        ],
        border: novert
      }
    ],
    [
      {},
      { text: 'S' },
      { text: 'STOP', fillColor: colors.stop },
      { text: 'STOP', fillColor: colors.stop },
      {
        style: 'left',
        columnGap: 3,
        columns: [
          {
            image: 'checkbox', width: 8
          },
          'VIM',
          {
            image: 'checkbox', width: 8
          },
          'IMP',
          {
            image: 'checkbox', width: 8
          },
          'NEG'
        ],
        border: novert
      }
    ],
    [
      { text: '-', rowSpan: 3 },
      { text: 'I/R', rowSpan: 2 },
      { text: 'I/R' },
      { text: 'Oui' },
      { text: '', border: novert }
    ],
    [
      {},
      {},
      { text: 'S' },
      { text: 'Non', fillColor: colors.no },
      { text: '', border: novert }
    ],
    [
      {},
      { text: 'S' },
      { text: 'STOP', fillColor: colors.stop },
      { text: 'STOP', fillColor: colors.stop },
      { text: 'Souche : __________________', border: notop }
    ]
  ]
  return {
    fontSize: 8,
    style: [ 'center', 'bold' ],
    table: {
      widths: [ 100, 50, 50, 24, 106 ],
      body: body
    },
    margin: [ 0, 4, 0, 4 ]
  }
}

const nobot = [ true, true, true, false ]
const novert = [ true, false, true, false ]
const notop = [ true, false, true, true ]

function eblse (n) {
  const body = [
    [
      {
        text: `EBLSE n°${n} : ______________________`,
        colSpan: 5
      }, {}, {}, {}, {}
    ],
    [
      'BANDELETTE\n____________ / ____________',
      'CEFTA\n_____________',
      'ERTA\n _____________',
      'Coris\nPCR',
      'Résultat'
    ],
    [
      { text: '+', rowSpan: 2 },
      { text: '', rowSpan: 2 },
      { text: 'I/R' },
      { text: 'Oui' },
      { text: 'EBLSE  +    -     PCR  +    -', border: nobot }
    ],
    [
      {},
      {},
      { text: 'S' },
      { text: 'Non', fillColor: colors.no },
      {
        style: 'left',
        columnGap: 3,
        columns: [
          {
            image: 'checkbox', width: 8
          },
          'KPC',
          {
            image: 'checkbox', width: 8
          },
          'OXA',
          {
            image: 'checkbox', width: 8
          },
          'NDM'
        ],
        border: novert
      }
    ],
    [
      { text: '-', rowSpan: 3 },
      { text: 'I/R', rowSpan: 2 },
      { text: 'I/R' },
      { text: 'Oui' },
      {
        style: 'left',
        columnGap: 3,
        columns: [
          {
            image: 'checkbox', width: 8
          },
          'VIM',
          {
            image: 'checkbox', width: 8
          },
          'IMP',
          {
            image: 'checkbox', width: 8
          },
          'NEG'
        ],
        border: novert
      }
    ],
    [
      {},
      {},
      { text: 'S' },
      { text: 'Non', fillColor: colors.no },
      { text: '', border: novert }
    ],
    [
      {},
      { text: 'S' },
      { text: 'STOP', fillColor: colors.stop },
      { text: 'STOP', fillColor: colors.stop },
      { text: 'Souche : __________________', border: notop }
    ]
  ]
  return {
    fontSize: 8,
    style: [ 'center', 'bold' ],
    table: {
      widths: [ 100, 50, 50, 24, 106 ],
      body: body
    },
    margin: [ 0, 4, 0, 4 ]
  }
}

function exportWorkbenchPDF (s) {
  const styles = {
    h1: {
      fontSize: 12,
      color: '#6F77D6'
    },

    center: {
      alignment: 'center'
    },

    left: {
      alignment: 'left'
    },

    bold: {
      bold: true
    }
  }

  const content = []
  const wps = {}
  s.modules.reaSink.waterPoints.forEach(
    wp => {
      if (wps[wp.room] == null) {
        wps[wp.room] = []
      }
      wps[wp.room].push(wp)
    }
  )

  let first = true
  for (let r in wps) {
    wps[r].forEach(
      (wp, i) => {
        const title = {
          text: getTitle(s, wp),
          style: [ 'h1' ]
        }
        if (first) {
          first = false
        } else {
          title.pageBreak = 'before'
        }
        content.push(title)
        content.push(
          {
            columns: [
              [
                eblse(1),
                eblse(2)
              ],
              [
                epc(),
                pyo()
              ]
            ]
          }
        )
      }
    )
  }

  const definition = {
    pageStyle: 'A4',
    pageOrientation: 'landscape',
    content: content,
    styles: styles,
    footer: (current, count) => {
      return {
        text: `${s.establishment.name} - page ${current}/${count}`,
        fontSize: 6,
        alignment: 'center'
      }
    },
    images: {
      checkbox: pdf.checkbox
    }
  }
  const filename = `SPIADI2020 - RÉA SINK - ${s.establishment.name}.pdf`
  pdf.createPdf(definition).download(filename)
}

export default {
  exportWorkbenchPDF: exportWorkbenchPDF
}
